import { useContext } from 'react'
import { ConfigContext } from '../store/ConfigContext'

const useLaunchdarkly = () => {
  const { flags } = useContext(ConfigContext)

  const pswApiClientId = flags?.['olex-psw-api-client-id']

  return {
    pswApiClientId
  }
}

export default useLaunchdarkly
